export function lowercaseExceptFirst(word: string): string {
  if (!word) return word;
  return word.charAt(0) + word.slice(1).toLowerCase();
}
